(() => {
  const SELECTOR = '[data-alpha-delivery-estimate]';

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setHours(12, 0, 0, 0);
    result.setDate(result.getDate() + days);
    return result;
  };

  const makeEstimate = (config) => {
    const productionDays = Number(config.dataset.productionDays || 14);
    const transitDays = Number(config.dataset.transitDays || 5);
    const locale = document.documentElement.lang || config.dataset.locale || 'fr';
    const formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long'
    });
    const today = new Date();
    const dispatchDate = formatter.format(addDays(today, productionDays));
    const deliveryDate = formatter.format(addDays(today, productionDays + transitDays));
    const estimate = document.createElement('div');
    estimate.className = 'alpha-delivery-estimate';
    estimate.dataset.alphaDeliveryEstimate = '';
    estimate.setAttribute('role', 'status');
    estimate.innerHTML = `
      <span class="alpha-delivery-estimate__icon" aria-hidden="true">✓</span>
      <p class="alpha-delivery-estimate__text">
        <strong>${config.dataset.orderToday}</strong>
        ${config.dataset.estimatedDispatch}
        <span class="alpha-delivery-estimate__date">${dispatchDate}</span>,
        ${config.dataset.deliveryAround}
        <span class="alpha-delivery-estimate__date">${deliveryDate}</span>.
      </p>
    `;
    return estimate;
  };

  const findPurchaseButton = () => {
    const configurator = document.querySelector('[data-alpha-configurator]');
    if (!configurator) return null;
    return configurator.querySelector('.alpha-configurator__button') ||
      [...configurator.querySelectorAll('button')].find((button) =>
        /ajouter au panier|add to cart/i.test((button.textContent || '').trim())
      );
  };

  const mount = () => {
    const config = document.querySelector('[data-alpha-delivery-config]');
    const button = findPurchaseButton();
    if (!config || !button || document.querySelector(SELECTOR)) return false;
    button.insertAdjacentElement('afterend', makeEstimate(config));
    return true;
  };

  const start = () => {
    if (mount()) return;
    const observer = new MutationObserver(() => {
      if (mount()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
